import { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const navigation = [
  { name: 'Home',         href: '/' },
  { name: 'Projects',     href: '/projects' },
  { name: 'Capabilities', href: '/capabilities' },
  { name: 'About',        href: '/about' },
  { name: 'Career',       href: '/career' },
  { name: 'Contact',      href: '/contact' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-navy-950/95 backdrop-blur-sm border-b border-navy-600 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/">
            <img src="/images/logo.jpeg" alt="BPR Electric" className="h-12 w-auto" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-slate-400 hover:text-white transition-colors duration-200 font-sans text-sm"
              >
                {item.name}
              </Link>
            ))}
            <div className="flex items-center space-x-2 text-primary-500">
              <Phone className="h-4 w-4" />
              <span className="font-heading uppercase text-sm tracking-wide">(617) 848-3498</span>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-slate-400 hover:text-white focus:outline-none"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="md:hidden py-4 border-t border-navy-600"
          >
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="block py-3 text-slate-400 hover:text-white transition-colors duration-200 font-sans text-sm"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <div className="flex items-center space-x-2 text-primary-500 pt-3">
              <Phone className="h-4 w-4" />
              <span className="font-heading uppercase text-sm tracking-wide">(617) 848-3498</span>
            </div>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
